import { createNumberMask } from 'text-mask-addons';
import { MASKS } from 'ng-brazil';
import { testCAEPF } from '@core/config/caepf-validador-config';

export const Masks = {
    telefone: (value) => {
        let numbers = value.match(/\d/g);
        let numberLength = 0;
        if (numbers) {
            numberLength = numbers.join("").length;
        }

        if (numberLength > 10) {
            return ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        } else {
            return ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        }
    },
    nome: Array(150).fill(/[A-Za-zÀ-ÖØ-öø-ÿ\s]/),
    cpf: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
    cnpj: [/[A-Za-z0-9]/, /[A-Za-z0-9]/, '.', /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '.', /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '/', /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '-', /\d/, /\d/],
    contrato: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
    decimal: createNumberMask({
        decimalSymbol: ',',
        prefix: '',
        includeThousandsSeparator: false,
        allowDecimal: true,
        decimalLimit: 9
    }),
    currency: MASKS.currency.textMask,
    integer: createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        allowLeadingZeroes: true,
    }),
    periodoAno: [/\d/, /\d/, /\d/, /\d/],
    data: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    cpfCnpj: (value) => {
        let alphanumeric = value.match(/[a-zA-Z]/g)
        const cleanValue = (value.match(/[A-Za-z0-9]/g) || []).join('');
        const valueLength = cleanValue.length;
        return valueLength > 11 || alphanumeric ? Masks.cnpj : Masks.cpf
    },
    cep: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
    susep: [/\d/, /\d/, /\d/, /\d/, /\d/],
    ip: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/],
    imei: [/\w/, /\w/, /\w/, /\w/, /\w/, /\w/, '-', /\w/, /\w/, '-', /\w/, /\w/, /\w/, /\w/, /\w/, /\w/, '-', /\w/],
    any: Array(240).fill(/.*/), // Array com 240 caracteres livres
    chassi: [/[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/],
    placa: [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[0-9]/, /[A-Za-z0-9]/, /[0-9]/, /[0-9]/],
    caepf: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
    cnpjCaepf: (value) => {
        let numbers = value.match(/\d/g);
        let numberLength = 0;
        if (numbers) {
            numberLength = numbers.join("").length;
        }
        let isCaepf = testCAEPF(value)
        if (!isCaepf) {
            return Masks.cnpj
        } else if (isCaepf) {
            return Masks.caepf
        }
    },
    cpfCnpjCaepf: (value) => {
        let numbers = value.match(/\d/g);
        let numberLength = 0;
        if (numbers) {
            numberLength = numbers.join("").length;
        }

        if (numberLength > 11) {
            return Masks.cnpjCaepf(value)
        } else {
            return Masks.cpf
        }
    },
    cnae: [/[0-9]/, /[0-9]/],
    char: Array(240).fill(/^([A-Za-zá-úÁ-ÚàâãèêïôõöçñÀÂÃÈÏÔÕÖÇÑ\s]{1,240})$/),
    renavam: [/[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/],
    alphanumeric: Array(240).fill(/^([A-Za-z0-9\s]{1,240})$/),
    coordenada: [
        /[\-–—-−‒―]?/,
        /[1-9]/,
        /[0-9.]?/,
        /[0-9.]?/,
        /[0-9.]?/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
    ],
    car: [
        /[A-Za-z0-9]/, /[A-Za-z0-9]/, '-',
        /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '-',
        /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/,
        /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/,
        /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/,
        /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/,
        /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/,
        /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/,
        /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/,
        /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/,
        /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/,
        /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/
    ],
}
